import React from "react";
import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
  render() {
    const selectedSearchValues = this.props.selectedSearchValues;
    const cropSupplyDetails = this.props.cropSupplyDetails;
    const columnNames = this.props.columnNames;

    const options = {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };

    const availableMonthDates = columnNames.filter(x => x !== 'Route Name' && x !== 'Registration Number' && x !== 'Customer Name' && x !== 'Total');

    const cellStyle = {
      border: "1px solid #000",
      padding: "2px",
      fontSize: "8px",
      height: "10px"
    };

    const headerCellStyle = {
      border: "1px solid #000",
      padding: "2px",
      fontSize: "9px",
      fontWeight: "bold",
      backgroundColor: "#f5f5f5"
    };

    return (
      <div style={{ padding: '10px' }}>
        <h4 style={{ textAlign: 'center', margin: '2px 0', textDecoration: 'underline' }}>Crop Supply Periodical Report</h4>
        <h5 style={{ textAlign: 'center', margin: '2px 0' }}>Group - {selectedSearchValues.groupName} | Factory - {selectedSearchValues.factoryName}</h5>
        <h5 style={{ textAlign: 'center', margin: '2px 0' }}>Route - {selectedSearchValues.routeName || 'All'} | Reg. No. - {selectedSearchValues.registrationNumber || 'All'}</h5>
        <h5 style={{ textAlign: 'center', margin: '2px 0' }}>From {selectedSearchValues.startDate} to {selectedSearchValues.endDate}</h5>
        <div style={{ marginTop: '10px' }}>
          <Table size="small" style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
            <TableHead>
              <TableRow style={{ height: 'auto' }}>
                <TableCell style={{ ...headerCellStyle, width: '45px' }} align="left">Route</TableCell>
                <TableCell style={{ ...headerCellStyle, width: '30px' }} align="center">Reg.No</TableCell>
                <TableCell style={{ ...headerCellStyle, width: '65px' }} align="left">Customer</TableCell>
                {availableMonthDates.map((row, index) => (
                  <TableCell key={index} style={headerCellStyle} align="center">
                    M{(index + 1).toString().padStart(2, '0')}
                  </TableCell>
                ))}
                <TableCell style={{ ...headerCellStyle, width: '50px' }} align="right">Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cropSupplyDetails.map((row, index) => (
                <TableRow key={index} style={{ height: 'auto' }}>
                  <TableCell style={cellStyle} align="left">{row.routeName}</TableCell>
                  <TableCell style={cellStyle} align="center">{row.registrationNumber}</TableCell>
                  <TableCell style={cellStyle} align="left">{row.name}</TableCell>
                  {availableMonthDates.map((rows, cIndex) => {
                    const found = row.groupList.find(x => x.cropCollectedDate.split("T")[0] === rows);
                    return (
                      <TableCell key={cIndex} style={cellStyle} align="center">
                        {found === undefined ? '-' : (found.cropWeight === 0 ? '-' : found.cropWeight.toLocaleString('en-US', options))}
                      </TableCell>
                    );
                  })}
                  <TableCell style={{ ...cellStyle, fontWeight: 'bold' }} align="right">
                    {row.totalAmount.toLocaleString('en-US', options)}
                  </TableCell>
                </TableRow>
              ))}
              <TableRow style={{ height: 'auto' }}>
                <TableCell colSpan={3} style={{ ...cellStyle, fontWeight: 'bold' }} align="center">Total</TableCell>
                {availableMonthDates.map((day, index) => {
                  const dayTotal = cropSupplyDetails.reduce((total, row) => {
                    const found = row.groupList.find(x => x.cropCollectedDate.split("T")[0] === day);
                    return total + (found ? parseFloat(found.cropWeight) : 0);
                  }, 0);
                  return (
                    <TableCell key={index} style={{ ...cellStyle, fontWeight: 'bold' }} align="center">
                      {dayTotal !== 0 ? dayTotal.toLocaleString('en-US', options) : '-'}
                    </TableCell>
                  );
                })}
                <TableCell style={{ ...cellStyle, fontWeight: 'bold' }} align="right">
                  {cropSupplyDetails.reduce((total, row) => total + parseFloat(row.totalAmount), 0).toLocaleString('en-US', options)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        <div style={{ textAlign: 'center', fontSize: '10px', marginTop: '10px' }}>***** End of List *****</div>
      </div>
    );
  }
}
